<script lang="ts" context="module">
  export type Variant = "dark" | "darkGhost" | "light";
</script>

<script lang="ts">
  /**
   * Imports
   * ---------------------------------------------------------------------------
   */

  import { twJoin, twMerge } from "tailwind-merge";

  /**
   * Types
   * ---------------------------------------------------------------------------
   */

  type Size = "small" | "medium";

  /**
   * Props
   * ---------------------------------------------------------------------------
   */

  /** text */
  export let text: string | undefined = undefined;

  /** variant presets */
  export let variant: Variant = "darkGhost";

  /** size */
  export let size: Size = "medium";

  /**
   * Data: Variant Mixins
   * ---------------------------------------------------------------------------
   */

  const variantContainerMixins: {
    [key in Variant]: string;
  } = {
    darkGhost: "bg-black/50",
    dark: "bg-n900",
    light: "bg-white",
  };
  const variantTextMixins: {
    [key in Variant]: string;
  } = {
    darkGhost: "text-white",
    dark: "text-white",
    light: "text-black",
  };

  /**
   * Data: Size Mixins
   * ---------------------------------------------------------------------------
   */

  const sizeContainerMixins: {
    [key in Size]: string;
  } = {
    small: "px-2.5 py-1.5",
    medium: "px-3 py-2",
  };
  const sizeTextMixins: {
    [key in Size]: string;
  } = {
    small: "wah-body-small",
    medium: "wah-body-base",
  };
</script>

<!-- Template ----------------------------------------------------------------->

<div
  class={twMerge(
    "rounded-full flex items-center justify-center",
    sizeContainerMixins[size],
    variantContainerMixins[variant],
    $$props.class,
  )}
>
  <p
    class={twJoin(
      "text-center",
      sizeTextMixins[size],
      variantTextMixins[variant],
    )}
  >
    {text}
  </p>
</div>
